export enum TimeSheetStatusErrorEnum {
	// time sheet has not been started by pilot (though there may be imported flights from CMS)
	NotStarted = '',

	// has been submitted by pilot for approval by admin
	SubmittedByEmployee = 'You cannot edit a submitted time sheet, please cancel your submission before making changes.',

	// has been approved by the admin and is ready to be exported
	ApprovedByAdmin = 'This time sheet is already approved, contact the Chief Pilot to make changes',

	// has been exported to workday
	Paid = 'This time sheet has already been submitted to payroll. Please add an Adjustment from the current time sheet.'
}
